import ValidationStore from 'lib/stores/validationStore';
import ConfigStore from 'lib/stores/configStore';
import ValidationTypes from 'lib/constants/validationTypes';

export default function useFieldValidation(
  fieldName: string,
  type: string,
): [boolean | null, string] {
  let actualName: string;

  if (type === ValidationTypes.PHONE || type === ValidationTypes.EMAIL) {
    actualName = fieldName.split('.').slice(-2).join('_');
  } else {
    actualName = fieldName.split('.').slice(-1).pop();
  }

  const page: string = ConfigStore.useState(state => state.currentPage);
  const validations = ValidationStore.useState(
    state => state[page][actualName] || {},
    [page],
  );

  const { valid = null, errors = [] } = validations;

  return [valid, errors.slice(-1)[0]];
}
